import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M6 0V12",
      stroke: "#AA1E2D",
      "stroke-width": "1.75"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12 6L4.47035e-07 6",
      stroke: "#AA1E2D",
      "stroke-width": "1.75"
    }, null, -1)
  ]))]))
}
export default { render: render }